import ___default from "lodash";
import { CompositionActionType, CompositionChangeType, FlightDependencyItemLevel } from "../Composition.types.js";
import { AsyncRequestStatus } from "@ane/core/lib/models";
import { compareIgnoreCase } from "@ane/core/lib/utils/CommonStringUtils";
const convertFlightDependencies = (rootFlightName, flightEditResponse) => {
  const relatedFlights = ___default.map(flightEditResponse.FlightEditResponseItems, (responseItem) => {
    return {
      name: responseItem.FlightName,
      isolationGroups: flightEditResponse.FlightIsolationGroupsMap[responseItem.FlightName] || [],
      isRunning: flightEditResponse.FlightRunningStatusMap[responseItem.FlightName] || false,
      dependencies: [
        { severityLevel: responseItem.SeverityLevel, message: responseItem.Message, itemType: responseItem.ItemType }
      ],
      composition: convertFlightCompositionMap(
        flightEditResponse.FlightCompositionMap[responseItem.FlightName],
        flightEditResponse
      )
    };
  });
  return moveRootFlightToTop(rootFlightName, relatedFlights, flightEditResponse);
};
const moveRootFlightToTop = (rootFlightName, dependencies, flightEditResponse) => {
  const rootFlightIndex = ___default.findIndex(dependencies, (d) => compareIgnoreCase(d.name, rootFlightName));
  if (rootFlightIndex < 0) {
    const rootFlight = {
      name: rootFlightName,
      isolationGroups: flightEditResponse.FlightIsolationGroupsMap[rootFlightName],
      isRunning: flightEditResponse.FlightRunningStatusMap[rootFlightName],
      composition: convertFlightCompositionMap(flightEditResponse.FlightCompositionMap[rootFlightName], flightEditResponse),
      dependencies: []
    };
    return [rootFlight].concat(dependencies);
  } else {
    return [dependencies[rootFlightIndex], ...dependencies.slice(0, rootFlightIndex), ...dependencies.slice(rootFlightIndex + 1)];
  }
};
const convertFlightCompositionMap = (composition, flightEditResponse) => {
  return ___default.map(composition, (child) => {
    var _a;
    return {
      flightName: child.FlightName,
      forceAssignOnNumberline: child.ForceAssignOnNumberline,
      isRunning: (_a = flightEditResponse.FlightRunningStatusMap[child.FlightName]) != null ? _a : false,
      availableAction: CompositionActionType.Remove,
      change: CompositionChangeType.None,
      isInExistingComposition: true
    };
  });
};
const validateComposition = (composition, flightQueries) => {
  const errors = [];
  const newlyAddedFlights = ___default.filter(composition, (c) => c.change === CompositionChangeType.Added);
  const failedQueries = ___default.filter(newlyAddedFlights, (f) => {
    var _a;
    return ((_a = flightQueries[f.flightName]) == null ? void 0 : _a.status) === AsyncRequestStatus.Failed;
  });
  if (failedQueries.length > 0) {
    errors.push(`Flight ${failedQueries[0].flightName} does not exist. Flight must be registered before it can be composed.`);
  }
  const childFlightNames = ___default.map(composition, (c) => c.flightName);
  if (new Set(childFlightNames).size !== childFlightNames.length) {
    errors.push("Composition contains duplicate children.");
  }
  return errors;
};
const buildCompositionUpdateRequest = (flightId, flightCompositions) => {
  const requestItems = ___default.map(Object.keys(flightCompositions), (flightName) => {
    const filteredCompositions = ___default.filter(flightCompositions[flightName], (c) => c.change !== CompositionChangeType.Removed);
    const compositionChildren = ___default.map(filteredCompositions, (c) => {
      var _a;
      return {
        FlightName: c.flightName,
        ForceAssignOnNumberline: (_a = c.forceAssignOnNumberline) != null ? _a : false
      };
    });
    return {
      FlightName: flightName,
      CompositionChildren: compositionChildren
    };
  });
  return {
    SelectedFlight: flightId,
    RequestItems: requestItems
  };
};
const isResultBlocking = (flightEditResponse) => {
  return ___default.some(flightEditResponse == null ? void 0 : flightEditResponse.FlightEditResponseItems, (item) => item.SeverityLevel >= FlightDependencyItemLevel.Blocking);
};
const resultBlockingMessage = (flightEditResponse) => {
  var _a, _b;
  return (_b = (_a = ___default.find(flightEditResponse == null ? void 0 : flightEditResponse.FlightEditResponseItems, (item) => item.SeverityLevel >= FlightDependencyItemLevel.Blocking)) == null ? void 0 : _a.Message) != null ? _b : "No Error information present";
};
const getSubmissionResultMessage = (isVerificationSuccess, error) => {
  if (isVerificationSuccess) {
    return "The changes were successfully committed. The changes may take up to 30 minutes before they are reflected in the composition and experiments.";
  } else {
    return "The proposed changes have blocking issues. The changes were not successfully committed. Error: " + error;
  }
};
export {
  buildCompositionUpdateRequest,
  convertFlightCompositionMap,
  convertFlightDependencies,
  getSubmissionResultMessage,
  isResultBlocking,
  moveRootFlightToTop,
  resultBlockingMessage,
  validateComposition
};
//# sourceMappingURL=CompositionEdit.utils.js.map
